export const VIS_MAX_TITLE_LENGTH = 20;
